export var appActivationByTabDirective = {

    methods:{
        onFocus(){
            console.log('onFocus Base');
        },
        onBlur(){
            console.log('onBlur Base');
        }
    },

    mounted(){
        window.addEventListener('focus', this.onFocus);
        window.addEventListener('blur', this.onBlur);
    },
    beforeDestroy(){
        window.removeEventListener('focus', this.onFocus);
        window.removeEventListener('blur', this.onBlur);
    }
}